// frontend/src/components/charts/Chart.jsx
// The one AG Charts component in the app: every chart renders through it and
// takes the house theme from hooks/useChartTheme.

import React, { useMemo } from 'react';
import { AgCharts } from 'ag-charts-react';

import { useChartTheme } from '../../hooks/useChartTheme';

const VALIDATIONS = import.meta.env.DEV
  ? { throwOn: ['error', 'warning', 'deprecation'] }
  : undefined;

export default function Chart({ options, className }) {
  const { agTheme } = useChartTheme();
  const themed = useMemo(
    () => ({ ...options, theme: agTheme, validations: VALIDATIONS }),
    [options, agTheme],
  );
  return <AgCharts options={themed} className={className} />;
}
